import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse } from '../types/api';

export interface BookingRecurringTimesDay {
  day: { id?: number; code?: string; label?: string };
  startTime?: string;
  endTime?: string;
}

export interface BookingRecurringTimesRequest {
  start: string;
  end: string;
  days: BookingRecurringTimesDay[];
}

export interface BookingRecurringDate {
  start: string;
  end: string;
}

const URL = '/v2/booking-recurring-times';

class BookingRecurringTimesService {
  static create(
    data: BookingRecurringTimesRequest,
    config?: AxiosRequestConfig,
  ): Promise<DataResponse<BookingRecurringDate[]>> {
    return axios.post(URL, data, config);
  }
}

export { BookingRecurringTimesService };
